import { useQuery } from '@tanstack/react-query';
import { Spinfinity, Typography } from 'components';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { getConditionMetricCountsQuery } from 'services/conditions/useConditionMetrics';
import Box from './ConditionMetricsBox';
import styles from './ConditionMetricsBoxes.module.css';

export default function ConditionMetricsBoxes() {
  const { currentKit } = useCurrentKitAndTinyAccount();
  const {
    data: conditionMetrics,
    isLoading,
    error,
  } = useQuery({
    ...getConditionMetricCountsQuery(currentKit?.id, 20),
    enabled: !!currentKit?.id,
    retry: 1,
  });

  if (isLoading)
    return (
      <div className='flex justify-center items-center mt-4 py-4'>
        <Spinfinity />
      </div>
    );

  if (
    error ||
    !currentKit ||
    !conditionMetrics ||
    conditionMetrics.length === 0
  )
    return (
      <div className='flex justify-center items-center py-4'>
        <Typography variant='body-s' className='text-gray-500'>
          Unable to load condition metrics
        </Typography>
      </div>
    );

  return (
    <div className={styles.boxesContainer}>
      {conditionMetrics.slice(0, 4).map((cm, index) => (
        <Box
          key={`${cm.condition_id}-${index}`}
          conditionMetric={cm}
          conditionMetricsLength={conditionMetrics.length}
          conditionMetricIndex={index}
          conditionMetrics={conditionMetrics}
        />
      ))}
    </div>
  );
}
